import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { map, tap, catchError } from 'rxjs/operators';
import { CasesRepository } from '../../../infrastructure/repositories/cases.repository';
import { CasesState } from '../../states/cases.state';
import { GetChecklistStepsQuery } from './get-checklist-steps.query';
import { GetChecklistStepsResult } from './get-checklist-steps.result';

/**
 * Get checklist steps use case.
 * Retrieves checklist steps for a case.
 */
@Injectable({ providedIn: 'root' })
export class GetChecklistStepsUseCase {
  private readonly _repository = inject(CasesRepository);
  private readonly _state = inject(CasesState);

  public execute(query: GetChecklistStepsQuery): Observable<GetChecklistStepsResult> {
    this._state.setLoadingChecklistSteps(true);
    this._state.setErrorChecklistSteps(null);

    return this._repository.getChecklistSteps(query.caseId).pipe(
      tap((checklistSteps) => {
        this._state.setChecklistSteps(checklistSteps);
        this._state.setLoadingChecklistSteps(false);
      }),
      map((checklistSteps) => ({ checklistSteps })),
      catchError((error) => {
        this._state.setErrorChecklistSteps(error.message || 'Failed to get checklist steps');
        this._state.setLoadingChecklistSteps(false);
        return throwError(() => error);
      })
    );
  }
}
